module.exports = __webpack_public_path__ + "img/scheller.db7d2487.png";